// File: src/components/car/SimilarCars.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { searchCarsAdvanced } from '../../services/car';
import './SimilarCars.css';

const SimilarCars = ({ currentCar }) => {
  const [similarCars, setSimilarCars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSimilarCars = async () => {
      if (!currentCar) {
        console.log('❌ No current car provided to SimilarCars');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        console.log('🔍 Fetching similar cars for:', currentCar.brand);

        const minPrice = parseFloat(currentCar.price) * 0.8;
        const maxPrice = parseFloat(currentCar.price) * 1.2;

        const response = await searchCarsAdvanced({
          brand: currentCar.brand,
          minPrice: minPrice.toString(),
          maxPrice: maxPrice.toString(),
          per_page: 5
        });

        console.log('📊 Similar cars response:', response);

        const filtered = (response.data || [])
          .filter(car => car.id !== currentCar.id)
          .slice(0, 4);

        console.log(`✅ Found ${filtered.length} similar cars`);
        setSimilarCars(filtered);
      } catch (error) {
        console.error('❌ Error fetching similar cars:', error);
        setSimilarCars([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSimilarCars();
  }, [currentCar]);

  if (loading) {
    return (
      <div className="similar-cars-section">
        <h3 className="section-title">Similar Cars</h3>
        <div className="similar-cars-loading">
          <div className="spinner-small"></div>
          <p>Loading similar cars...</p>
        </div>
      </div>
    );
  }

  if (similarCars.length === 0) {
    console.log('⚠️ No similar cars to display');
    return (
      <div className="similar-cars-section">
        <h3 className="section-title">Similar Cars</h3>
        <p className="no-similar-cars">No similar cars available at the moment.</p>
      </div>
    );
  }

  return (
    <div className="similar-cars-section">
      <h3 className="section-title">Similar Cars</h3>
      
      <div className="similar-cars-grid">
        {similarCars.map((car) => (
          <Link 
            key={car.id} 
            to={`/car/${car.id}`}
            className="similar-car-card"
            onClick={() => window.scrollTo(0, 0)}
          >
            <div className="similar-car-image">
              {car.images_urls && car.images_urls[0] ? (
                <img
                  src={`http://localhost:3001${car.images_urls[0]}`}
                  alt={car.title}
                  loading="lazy"
                />
              ) : (
                <div className="no-image-placeholder">No Image</div>
              )}
            </div>
            
            <div className="similar-car-info">
              <h4 className="similar-car-name">{car.brand} {car.model}</h4>
              <p className="similar-car-details">
                {car.km_driven || car.mileage} km • {car.fuel_type} • {car.transmission}
              </p>
              <div className="similar-car-price">
                ₹{parseFloat(car.price).toLocaleString('en-IN')}
              </div>
              <div className="similar-car-emi">
                EMI from ₹{Math.round(parseFloat(car.price) / 60).toLocaleString('en-IN')}/m
              </div>
              <div className="similar-car-badge">
                🏷️ {car.location}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SimilarCars;